//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as articlesAction from '../action/articlesAction';

//Func

//Material-ui
//Add
import axios from 'axios';
import config from '../config';

//Part
import PartPageTitle from './PartPageTitle';
//Dialog
//Icon

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      title: null,
      date: null,
      releaseDate: null,
      img: null,
      comment: '',
      view: 0,
    }
  }

  componentDidMount() {
    let id = this.props.match.params.id;
    const params = new URLSearchParams();
    params.append('id', id);
    axios.post(config.apiUri + "articlesItemApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      if(res.data.bool) {
        this.setState({
          title: res.data.articles_title,
          date: res.data.articles_date,
          releaseDate: res.data.articles_release_date,
          img: res.data.articles_img,
          comment: res.data.articles_comment,
          view: res.data.articles_view,
        })
        document.title = 'コラム ' + res.data.articles_title + ' - パートナーズ';
      }

    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }






	render() {

    let createMarkup = () => {
      return {__html: this.state.comment};
    }

		return (
      <div>
        <PartPageTitle
          title={this.state.title}
          onback={ '/articles/' }
        />

        <div
          style={{margin:'2%'}}
        >
          {this.state.date} 更新 {this.state.view} view
        </div>
        {
          (this.state.img) && (
            <img
              src={'//d350vy86j0t5cz.cloudfront.net/articles/?file=' + this.state.img + "&W=800&H=800&crop=0"}
              style={{width:"100%", height: "auto", boxSizing:'border-box'}}
              alt=''
            />
          )
        }


        <div
          style={{margin:'2%'}}
          dangerouslySetInnerHTML={ createMarkup() }
        >
        </div>



      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		articles: state.articles,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...articlesAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
